import { ClassificationResult, MarketCode } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

export function classificationResultToText(result: ClassificationResult) {
  switch (result) {
    case ClassificationResult.Employee:
    case ClassificationResult.LikelyEmployee:
      return $t('Employee')
    case ClassificationResult.Independent:
    case ClassificationResult.LikelyIndependent:
      return $t('Independent Contractor')
    default:
      return $t('Unknown')
  }
}

export function classificationResultByMarketToText(
  result: ClassificationResult,
  currentMarket: MarketCode | undefined,
) {
  switch (result) {
    case ClassificationResult.Employee:
    case ClassificationResult.LikelyEmployee:
      if (currentMarket === MarketCode.Us) {
        return 'W-2 (Employee)'
      }
      if (currentMarket === MarketCode.Uk) {
        return 'IR35 (Employee)'
      }
      return $t('Employee')
    case ClassificationResult.Independent:
    case ClassificationResult.LikelyIndependent:
      if (currentMarket === MarketCode.Us) {
        return '1099 (Independent Contractor)'
      }
      if (currentMarket === MarketCode.Uk) {
        return 'Outside IR35 (Independent Contractor)'
      }

      return $t('Independent Contractor')
    default:
      return $t('Unknown')
  }
}

export function determinationResultToText(
  result: string,
  currentMarket: MarketCode | undefined = undefined,
) {
  // Do the result conversion here for the enum app/Services/Determinations/Enums/DeterminationResult.php
  // The enum does not exist in our typescript setup so we have to rely on string conversion
  switch (result) {
    case 'inside':
      return classificationResultToText(ClassificationResult.Employee)
    case 'likely-inside':
      return classificationResultToText(ClassificationResult.LikelyEmployee)
    case 'outside':
      return classificationResultToText(ClassificationResult.Independent)
    case 'likely-outside':
      return classificationResultToText(ClassificationResult.LikelyIndependent)
  }
  return classificationResultByMarketToText(ClassificationResult.Unknown, currentMarket)
}

export function determinationResultByMarketToText(
  result: string,
  currentMarket: MarketCode | undefined,
) {
  // Do the result conversion here for the enum app/Services/Determinations/Enums/DeterminationResult.php
  // The enum does not exist in our typescript setup so we have to rely on string conversion
  switch (result) {
    case 'inside':
      return classificationResultByMarketToText(ClassificationResult.Employee, currentMarket)
    case 'likely-inside':
      return classificationResultByMarketToText(ClassificationResult.LikelyEmployee, currentMarket)
    case 'outside':
      return classificationResultByMarketToText(ClassificationResult.Independent, currentMarket)
    case 'likely-outside':
      return classificationResultByMarketToText(
        ClassificationResult.LikelyIndependent,
        currentMarket,
      )
  }
  return classificationResultByMarketToText(ClassificationResult.Unknown, currentMarket)
}
